import React from 'react';
import { supplierStars } from '../../lib/marketRating';

// Five stars with partial fill (4.3 → four full, the fifth 30%), the number
// beside them. Renders nothing for a missing or invalid rating — never zero
// stars, which would read as a bad supplier rather than an unknown one.

const PATH = 'M10 1.5l2.6 5.3 5.9.9-4.25 4.15 1 5.85L10 14.95 4.75 17.7l1-5.85L1.5 7.7l5.9-.9z';

export default function StarRating({ rating, size = 16, label, outOf = '/ 5', compact = false }) {
  const s = supplierStars(rating);
  if (!s) return null;
  return (
    <span data-star-rating={s.value} role="img" aria-label={label ? `${label}: ${s.text} ${outOf}` : `${s.text} ${outOf}`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: compact ? 4 : 6, direction: 'ltr' }}>
      <span style={{ display: 'inline-flex', gap: 1 }} aria-hidden="true">
        {s.fills.map((f, i) => (
          <span key={i} data-star-fill={f} style={{ position: 'relative', width: size, height: size, display: 'inline-block' }}>
            <svg viewBox="0 0 20 20" width={size} height={size} style={{ position: 'absolute', inset: 0 }}>
              <path d={PATH} fill="var(--star-empty, #E3DCCF)" />
            </svg>
            {f > 0 && (
              <span style={{ position: 'absolute', inset: 0, width: `${f * 100}%`, overflow: 'hidden' }}>
                <svg viewBox="0 0 20 20" width={size} height={size}>
                  <path d={PATH} fill="var(--star-fill, #C9962B)" />
                </svg>
              </span>
            )}
          </span>
        ))}
      </span>
      <strong style={{ fontSize: compact ? 12 : 13.5, color: 'var(--text-primary)', fontFamily: 'inherit' }}>
        {s.text}<span style={{ fontWeight: 400, color: 'var(--text-muted)', fontSize: compact ? 11 : 12 }}> {outOf}</span>
      </strong>
    </span>
  );
}
